/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { Database, RefreshCw, CheckCircle2, Clock, Download, Shield, Activity, FileText, ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from 'lucide-react';
import axios from 'axios';

export default function ReportesSnapshots() {
  // --- ESTADOS: SNAPSHOTS AWS ---
  const [snapshots, setSnapshots] = useState([]);
  const [loadingSnapshots, setLoadingSnapshots] = useState(true);

  // --- ESTADOS: REPORTES DRS ---
  const [reportesDrs, setReportesDrs] = useState([]);
  const [loadingDrs, setLoadingDrs] = useState(true);
  const [generandoDrs, setGenerandoDrs] = useState(false);
  const [descargandoDrsId, setDescargandoDrsId] = useState(null);
  
  // PAGINACIÓN DRS
  const [paginaActualDrs, setPaginaActualDrs] = useState(1);
  const itemsPorPaginaDrs = 10;
  
  // Selectores por defecto
  const [mesDrs, setMesDrs] = useState(new Date().getMonth() + 1);
  const [quincenaDrs, setQuincenaDrs] = useState(1);

  const [lastUpdate, setLastUpdate] = useState(new Date().toLocaleTimeString());
  const cardClasses = 'bg-white/5 backdrop-blur-xl border border-white/10 rounded-[2.5rem] p-8 shadow-2xl';

  // --- LLAMADAS A LA API ---
  const fetchSnapshots = async () => {
    setLoadingSnapshots(true);
    try {
      const response = await axios.get('https://healthcenter.kloud-pilot.com/reportes/api/monitoring/snapshots/');
      setSnapshots(response.data.data || response.data);
    } catch (error) { console.error("Error snapshots:", error); } 
    finally { setLoadingSnapshots(false); }
  };

  const fetchReportesDrs = async () => {
    setLoadingDrs(true);
    try {
      const response = await axios.get('https://healthcenter.kloud-pilot.com/reportes/api/monitoring/reportes-drs/');
      setReportesDrs(response.data); 
    } catch (error) { console.error("Error reportes DRS:", error); } 
    finally { setLoadingDrs(false); }
  };

  // --- DISPARADORES Y DESCARGAS ---
  const dispararDrs = async (e) => {
    e.preventDefault();
    if (!mesDrs || !quincenaDrs) return alert("Selecciona mes y quincena.");
    
    setGenerandoDrs(true);
    try {
      await axios.post('https://healthcenter.kloud-pilot.com/reportes/api/monitoring/disparar-drs/', {
        mes: mesDrs, quincena: quincenaDrs
      });
      alert("¡Reporte DRS encolado exitosamente!");
      fetchReportesDrs();
    } catch (error) { 
      alert("Error al comunicar con el servidor."); 
    } finally { 
      setGenerandoDrs(false); 
    }
  };

  const descargarDrs = async (id, mes, quincena) => {
    setDescargandoDrsId(id); 
    try {
      const response = await axios.get(`https://healthcenter.kloud-pilot.com/reportes/api/monitoring/descargar-drs/${id}/`, { responseType: 'blob' });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Reporte_DRS_${mes}_${quincena}.pdf`); 
      document.body.appendChild(link); 
      link.click(); 
      link.remove();
    } catch (error) { 
      alert("Error en descarga o el PDF no existe."); 
    } finally { 
      setDescargandoDrsId(null); 
    }
  };

  const refreshAll = () => {
    fetchSnapshots();
    fetchReportesDrs();
    setLastUpdate(new Date().toLocaleTimeString());
  };

  // Auto-refresh cada 5 minutos
  useEffect(() => {
    refreshAll();
    const interval = setInterval(refreshAll, 300000);
    return () => clearInterval(interval);
  }, []);

  // --- LÓGICA PAGINACIÓN DRS ---
  const indiceUltimoReporteDrs = paginaActualDrs * itemsPorPaginaDrs;
  const indicePrimerReporteDrs = indiceUltimoReporteDrs - itemsPorPaginaDrs;
  const reportesActualesDrs = reportesDrs.slice(indicePrimerReporteDrs, indiceUltimoReporteDrs);
  const totalPaginasDrs = Math.ceil(reportesDrs.length / itemsPorPaginaDrs);

  const cambiarPaginaDrs = (numeroPagina) => setPaginaActualDrs(numeroPagina);

  return (
    <div className="min-h-screen bg-[#0a0020] text-white p-8 font-sans">
      
      {/* HEADER */}
      <div className="flex justify-between items-center mb-10">
        <div>
          <h1 className="text-4xl font-black tracking-tight bg-gradient-to-r from-[#04d9ff] via-[#00ffb3] to-[#04d9ff] bg-clip-text text-transparent uppercase">
            Snapshots & DRS
          </h1>
          <p className="text-xs font-medium tracking-widest uppercase opacity-50 mt-1 flex items-center gap-2">
            <Database size={12} className="text-[#04d9ff]" /> Respaldo y Recuperación de Desastres
          </p> 
        </div>
        
        <div className="flex items-center gap-4">
          <div className="text-right">
            <p className="text-[10px] opacity-40 uppercase font-bold tracking-tighter">Última sincronización</p>
            <p className="text-sm font-mono text-[#00ffb3]">{lastUpdate}</p>
          </div>
          <button onClick={refreshAll} className="p-4 bg-white/5 hover:bg-white/10 border border-white/10 rounded-2xl transition-all">
            <RefreshCw size={20} className={`${loadingSnapshots || loadingDrs ? 'animate-spin' : ''}`} />
          </button>
        </div>
      </div>

      <div className={cardClasses}>
        <div className="flex items-center justify-between mb-8">
          <h2 className="text-xl font-bold uppercase tracking-tight flex items-center gap-3">
            <Shield className="text-[#04d9ff]" /> Generación de Reportes DRS
          </h2>
          <span className="px-4 py-1 bg-[#00ffb3]/10 text-[#00ffb3] text-[10px] font-black rounded-full border border-[#00ffb3]/20">
            AWS PROTECTED
          </span>
        </div>

        {/* FORMULARIO DRS */}
        <form onSubmit={dispararDrs} className="flex flex-wrap items-end gap-4 mb-12 p-6 bg-white/5 border border-white/10 rounded-3xl">
          <div className="flex-1 min-w-[200px]">
            <label className="block text-[10px] uppercase tracking-widest opacity-50 mb-2 font-bold">Mes del Reporte</label>
            <select value={mesDrs} onChange={(e) => setMesDrs(e.target.value)} className="w-full bg-[#0a0020] border border-white/20 text-white rounded-xl p-3 text-sm focus:outline-none focus:border-[#04d9ff] transition cursor-pointer">
              <option value="1">Enero</option>
              <option value="2">Febrero</option>
              <option value="3">Marzo</option>
              <option value="4">Abril</option>
              <option value="5">Mayo</option>
              <option value="6">Junio</option>
              <option value="7">Julio</option>
              <option value="8">Agosto</option>
              <option value="9">Septiembre</option>
              <option value="10">Octubre</option>
              <option value="11">Noviembre</option>
              <option value="12">Diciembre</option>
            </select>
          </div>
          
          <div className="flex-1 min-w-[250px]">
            <label className="block text-[10px] uppercase tracking-widest opacity-50 mb-2 font-bold">Periodo (Quincena)</label>
            <select value={quincenaDrs} onChange={(e) => setQuincenaDrs(e.target.value)} className="w-full bg-[#0a0020] border border-white/20 text-white rounded-xl p-3 text-sm focus:outline-none focus:border-[#04d9ff] transition cursor-pointer">
              <option value="1">1ra Quincena (Días 1 - 15)</option>
              <option value="2">2da Quincena (Días 16 - Fin de mes)</option>
            </select>
          </div>

          <button type="submit" disabled={generandoDrs} className="bg-[#04d9ff]/20 hover:bg-[#04d9ff]/30 border border-[#04d9ff]/50 text-[#04d9ff] font-bold px-6 py-3 rounded-xl flex items-center gap-2 disabled:opacity-50 text-sm transition-all">
            {generandoDrs ? <RefreshCw size={16} className="animate-spin" /> : <Shield size={16} />} Encolar Reporte
          </button>
        </form>

        <div className="grid grid-cols-1 xl:grid-cols-2 gap-12">
          
          {/* TABLA 1: HISTORIAL REPORTES DRS */}
          <div className="flex flex-col h-full">
            <h3 className="text-sm font-bold opacity-70 mb-4 uppercase tracking-widest flex items-center gap-2">
                <FileText size={16}/> Reportes Históricos
            </h3>
            <div className="overflow-x-auto bg-[#18181b] border border-gray-700 rounded-xl shadow-xl flex-grow">
              <table className="w-full text-left border-collapse">
                <thead>
                  <tr className="bg-[#27272a] border-b border-gray-700 text-[10px] uppercase tracking-wider text-gray-400">
                    <th className="p-4 font-semibold">Cliente</th>
                    <th className="p-4 font-semibold">Periodo</th>
                    <th className="p-4 font-semibold">Estado</th>
                    <th className="p-4 font-semibold text-center">Opciones</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-700">
                  {reportesActualesDrs.map((r, i) => (
                    <tr key={r.id || i} className="hover:bg-zinc-800/50 transition">
                      <td className="p-4 font-bold text-xs text-[#04d9ff]">{r.cliente}</td>
                      <td className="p-4 font-mono text-xs text-gray-300">{r.quincena} - {r.mes}</td>
                      <td className="p-4">
                        <div className="flex items-center gap-1.5">
                          {r.status === 'Completado' ? <CheckCircle2 size={14} className="text-[#00ffb3]" /> : <Clock size={14} className="text-amber-400" />}
                          <span className={`text-[10px] font-bold ${r.status === 'Completado' ? 'text-green-400' : 'text-amber-400'}`}>{r.status}</span>
                        </div>
                      </td>
                      <td className="p-4 text-center">
                        <button onClick={() => descargarDrs(r.id, r.mes, r.quincena)} disabled={descargandoDrsId === r.id || r.status !== 'Completado'} className="text-blue-400 hover:text-blue-300 flex items-center justify-center gap-1.5 mx-auto text-[10px] font-bold disabled:opacity-30 disabled:cursor-not-allowed transition">
                          {descargandoDrsId === r.id ? <RefreshCw size={14} className="animate-spin" /> : <Download size={14} />} PDF
                        </button>
                      </td>
                    </tr>
                  ))}
                  {reportesDrs.length === 0 && !loadingDrs && (
                      <tr>
                          <td colSpan="4" className="p-6 text-center text-gray-500 italic text-xs">No hay reportes DRS generados.</td>
                      </tr>
                  )}
                </tbody>
              </table>
            </div>
            
            {/* CONTROLES DE PAGINACIÓN DRS */}
            {reportesDrs.length > 0 && (
                <div className="flex justify-center items-center gap-2 mt-4">
                    <button 
                        onClick={() => cambiarPaginaDrs(1)} 
                        disabled={paginaActualDrs === 1}
                        className="px-2 py-1.5 bg-zinc-700 rounded hover:bg-zinc-600 disabled:opacity-30 disabled:cursor-not-allowed transition"
                    >
                        <ChevronsLeft size={14} />
                    </button>
                    <button 
                        onClick={() => cambiarPaginaDrs(paginaActualDrs - 1)} 
                        disabled={paginaActualDrs === 1}
                        className="px-2 py-1.5 bg-zinc-700 rounded hover:bg-zinc-600 disabled:opacity-30 disabled:cursor-not-allowed transition"
                    >
                        <ChevronLeft size={14} />
                    </button>

                    <div className="flex gap-1">
                        {[...Array(totalPaginasDrs)].map((_, idx) => {
                            const num = idx + 1;
                            if (num >= paginaActualDrs - 2 && num <= paginaActualDrs + 2) {
                                return (
                                    <button
                                        key={num}
                                        onClick={() => cambiarPaginaDrs(num)}
                                        className={`px-3 py-1 rounded transition text-xs font-bold ${
                                            paginaActualDrs === num 
                                            ? "bg-blue-600 text-white" 
                                            : "bg-zinc-700 text-white hover:bg-zinc-600"
                                        }`}
                                    >
                                        {num}
                                    </button>
                                );
                            }
                            return null;
                        })}
                    </div>

                    <button 
                        onClick={() => cambiarPaginaDrs(paginaActualDrs + 1)} 
                        disabled={paginaActualDrs === totalPaginasDrs}
                        className="px-2 py-1.5 bg-zinc-700 rounded hover:bg-zinc-600 disabled:opacity-30 disabled:cursor-not-allowed transition"
                    >
                        <ChevronRight size={14} />
                    </button>
                    <button 
                        onClick={() => cambiarPaginaDrs(totalPaginasDrs)} 
                        disabled={paginaActualDrs === totalPaginasDrs}
                        className="px-2 py-1.5 bg-zinc-700 rounded hover:bg-zinc-600 disabled:opacity-30 disabled:cursor-not-allowed transition"
                    >
                        <ChevronsRight size={14} />
                    </button>
                </div>
            )}
          </div>

          {/* TABLA 2: SNAPSHOTS RECIENTES */}
          <div className="flex flex-col h-full">
            <h3 className="text-sm font-bold opacity-70 mb-4 uppercase tracking-widest flex items-center gap-2">
                <Activity size={16}/> Actividad Reciente Snapshots
            </h3>
            <div className="overflow-x-auto bg-[#18181b] border border-gray-700 rounded-xl shadow-xl flex-grow">
              <table className="w-full text-left border-collapse">
                <thead>
                  <tr className="bg-[#27272a] border-b border-gray-700 text-[10px] uppercase tracking-wider text-gray-400">
                    <th className="p-4 font-semibold">Snapshot ID</th>
                    <th className="p-4 font-semibold">Estado</th>
                    <th className="p-4 font-semibold">Progreso</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-700">
                  {snapshots.slice(0, 10).map((s, i) => (
                    <tr key={i} className="hover:bg-zinc-800/50 transition">
                      <td className="p-4 font-bold text-[10px] text-gray-300">{s.snapshot_id}</td>
                      <td className="p-4">
                        <span className={`text-[10px] font-bold flex items-center gap-1.5 ${s.status === 'Completed' ? 'text-green-400' : 'text-amber-400'}`}>
                          {s.status === 'Completed' ? <span className="w-1.5 h-1.5 bg-green-500 rounded-full"></span> : <span className="w-1.5 h-1.5 bg-yellow-500 rounded-full animate-pulse"></span>}
                          {s.status}
                        </span>
                      </td>
                      <td className="p-4">
                        <div className="w-full max-w-[100px] bg-gray-700 h-1.5 rounded-full overflow-hidden">
                          <div className="bg-[#04d9ff] h-full transition-all duration-500" style={{ width: s.progress || '0%' }}></div>
                        </div>
                      </td>
                    </tr>
                  ))}
                  {snapshots.length === 0 && !loadingSnapshots && (
                      <tr>
                          <td colSpan="3" className="p-6 text-center text-gray-500 italic text-xs">No hay snapshots registrados recientes.</td>
                      </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}